import { gitWriteLockSelector } from "containers/Resources/Resources.selectors";
import { RecordType } from "graphql/generated/graphql";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export interface GitWriteLock {
    state: "WRITE_WAIT" | "WRITE_START" | "WRITE_SUCCEEDED" | "WRITE_FAILED";
    record: {
        type: RecordType;
        id: string;
    };
    lockfile: string;
    exception?: { title: string; message: string };
    // Whether the git write was initiated by an interactive Console user rather
    // than a system/background actor (a running flow or an internal
    // engine/git-sync call). Emitted by the backend git_write_lock pg_notify
    // payload. When false, a WRITE_FAILED is a system-initiated failure that the
    // interactive user did not cause and must not be toasted to them. Absent on
    // payloads from older backends -> treated as interactive (notify), preserving
    // prior behaviour.
    interactive?: boolean;
}

interface GitLockData {
    [id: string]: GitWriteLock;
}

export const useGitWriteLock = () => {
    const gitWriteLock: GitWriteLock[] = useSelector(gitWriteLockSelector);

    const currentGitLockData = useMemo(
        () =>
            gitWriteLock.reduceRight((acc: GitLockData, currentGitLock: GitWriteLock) => {
                const currentId = currentGitLock.record.id;
                if (!acc[currentId]) {
                    acc[currentId] = currentGitLock;
                }
                return acc;
            }, {}),
        [gitWriteLock]
    );

    return currentGitLockData;
};
